import {useToast} from 'vue-toastification';

export const formatError = (err: any) => {
  console.error(err);
  const toast = useToast();
  if (err instanceof Error) {
    toast.error(err.message);
  } else {
    toast.error(err);
  }
};

export const isCouponTestStore = (storeId: string) => {
  return [
    '6661d4ceaf7f676556049020',
    '6440fcce1bc2420066c4f1a2',
    '642a8e73e420910068bc7ffb',
    '64a690ca9c1eb10065b3251e',
    '59b9012ec6abe7002451cf35',
    '651be7af2befec0064978cca',
    '6814845eba180821f11b3da5',
    '662b5490884ceb0c4e02f8d6',
  ].includes(storeId);
};

export const isGlovoStore = (storeId: string) => {
  return [
    '59b9012ec6abe7002451cf35',
    '651be7af2befec0064978cca',
    '6440fcce1bc2420066c4f1a2',
    '642a8e73e420910068bc7ffb',
    '65dde5ba36138a8785243ea1',
  ].includes(storeId);
};

export const formatSuccess = (message: string) => {
  const toast = useToast();
  toast.success(message);
};

export const phoneRegex =
  /^\+\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

export const copyToClipboard = (data: string) => {
  const toast = useToast();
  navigator.clipboard.writeText(data);
  toast.success('Copiato negli appunti');
};

export function downloadCsv(content: string, fileName: string) {
  const blob = new Blob([content], {type: 'text/csv'});
  const urlForDownload = window.URL.createObjectURL(blob);
  const linkElement = document.createElement('a'); // create hyperlink HTML element

  linkElement.href = urlForDownload;
  linkElement.download = fileName;
  linkElement.click();

  URL.revokeObjectURL(urlForDownload); // free memory
}

export function downloadJson(content: string, fileName: string) {
  const blob = new Blob([content], {type: 'application/json'});
  const urlForDownload = window.URL.createObjectURL(blob);
  const linkElement = document.createElement('a'); // create hyperlink HTML element

  linkElement.href = urlForDownload;
  linkElement.download = fileName;
  linkElement.click();

  URL.revokeObjectURL(urlForDownload); // free memory
}

export const isMobileScreen = () => {
  return screen.width < 768;
};
